import { JsonLdSchema } from 'types/metadata'

export const PrepareSchema = (schema: JsonLdSchema): string | null => {
  if (typeof schema.url === 'string') {
    schema.url = encodeURI(schema.url)
  }

  const serialized = JSON.stringify(schema)

  // No Closing `</script>` (XSS Attacks)
  if (serialized.search(/<\/script/gi) > -1) {
    return null
  }

  return serialized
}
